export const AccerditionsRecognition = {
    enabled: true,
    Title: {
      text: "Accreditations & Recognitions",
      enabled: true,
    },
    Subtitle: {
      text: "Endorsements of Excellence, Recognitions and Accreditations \n Celebrating Academic Quality of Amity Online",
      enabled: true,
    },
    ImageList: [
      {
        enabled: true,
        title:
          "India's only Online MBA ranked by QS: Asia Pacific Top 10",
        alt: "Icon",
        url: null,
        target: null,
        source: {
          data: [
            {
              id: "1585",
              attributes: {
                alternativeText: null,
                url: "https://amityonline.com/_s/Group_48099254_1_46922cfc87_920634f33f.webp",
                width: 534,
                height: 537,
              },
            },
          ],
        },
      },
      {
        enabled: true,
        title:
          "First university in India to receive UGC approval for Online Degrees and Learning Platform",
        alt: "Icon",
        url: null,
        target: null,
        source: {
          data: [
            {
              id: "1586",
              attributes: {
                alternativeText: null,
                url: "https://amityonline.com/_s/UGC_c7308364f3_3878dcd669.webp",
                width: 136,
                height: 135,
              },
            },
          ],
        },
      },
      {
        enabled: true,
        title: "First Indian University to be accredited by National Council for Higher Education, Africa",
        alt: "Icon",
        url: null,
        target: null,
        source: {
          data: [
            {
              id: "1589",
              attributes: {
                alternativeText: null,
                url: "https://amityonline.com/_s/NCHE_Malawi_Logo1_377ed6cbbe_1_2ad697d3d1.webp",
                width: 538,
                height: 535,
              },
            },
          ],
        },
      },
      {
        enabled: true,
        title: "Accredited by the World Education Services",
        alt: "Icon",
        url: null,
        target: null,
        source: {
          data: [
            {
              id: "1588",
              attributes: {
                alternativeText: null,
                url: "https://amityonline.com/_s/Group_48099252_1_df96398b17_8a67bc8d63_b0fc08c271.webp",
                width: 534,
                height: 535,
              },
            },
          ],
        },
      },
      

      {
        enabled: true,
        title: "Ranked 32 by National Institutional Ranking Framework ",
        alt: "Icon",
        url: null,
        target: null,
        source: {
          data: [
            {
              id: "1590",
              attributes: {
                alternativeText: null,
                url: "https://amityonline.com/_s/Group_48100135_1_132c0a9195_e6090f88d3_5ed369393a.webp",
                width: 541,
                height: 537,
              },
            },
          ],
        },
      },
      {
        enabled: true,
        title:
          "Degree programs approved by All India Council of Technical Education",
        alt: "icon",
        url: null,
        target: null,
        source: {
          data: [
            {
              id: "1592",
              attributes: {
                alternativeText: null,
                url: "https://amityonline.com/_s/AICTE_6b131890a9_d8338806c8.webp",
                width: 134,
                height: 135,
              },
            },
          ],
        },
      },
      {
        enabled: true,
        title: "India's first private university to be a member",
        alt: null,
        url: null,
        target: null,
        source: {
          data: [
            {
              id: "1593",
              attributes: {
                alternativeText: null,
                url: "https://amityonline.com/_s/DEC_Main_Dark_72dpi_7b970c0a32_2a91b10ac8_bcfeb7420b.webp",
                width: 1000,
                height: 1000,
              },
            },
          ],
        },
      },
      {
        enabled: true,
        title: "Ranked among Top 3% Globally",
        alt: "icon",
        url: null,
        target: null,
        source: {
          data: [
            {
              id: "1591",
              attributes: {
                alternativeText: null,
                url: "https://amityonline.com/_s/the_62b2a634db_a5e332fa3c.webp",
                width: 136,
                height: 135,
              },
            },
          ],
        },
      },
      {
        enabled: true,
        title: "Accredited by the Western \n Association of Schools and College",
        alt: "Icon",
        url: null,
        target: null,
        source: {
          data: [
            {
              id: "1587",
              attributes: {
                alternativeText: null,
                url: "https://amityonline.com/_s/WASC_fb7127e339.webp",
                width: 541,
                height: 537,
              },
            },
          ],
        },
      },
    ],
  };

  export const WhyChooseAmityImmersionPage = {
    id: "1",
    enabled:true,
    Title: {   
      enabled:true,
      text: "Why Choose Amity Online?" 
    },
    Subtitle: { enabled:true, text: "Be ahead with\nIndustry-first Advantages" },
    ImageList: [
      {
        Image:
          "https://amityonline.com/_s/industry_1_7798c87e72.webp",
        Title: { text: "Industry Visits for\n Real-World \nExposure " },
        Subtitle: {
          text: "Experience hands-on learning through visits to top industry workplaces.",
        },
      },
      {
        Image:
          "https://amityonline.com/_s/Dedicated_Academic_Advisors_12de4fdfc3.webp",
        Title: { text: "Dedicated Academic\nAdvisor" },
        Subtitle: {
          text: "Dedicated experts and advisor to guide you at every step of your professional career",
        },
      },
      {
        Image:
          "https://amityonline.com/_s/AI_Professor_AMI_cdac4f71ed.webp",
        Title: { text: "AI-Professor\nAMI" },
        Subtitle: {
          text: "Powered by Chat-GPT 4 and \nopen AI-driven technology for online learning",
        },
      },
      {
        Image:
          "https://amityonline.com/_s/Placementopportunities_257e9e577a.webp",
        Title: { text: "Placement \nOpportunities" },
        Subtitle: {
          text: "Job interview prepration, placement assistance & resume building for students to be job-ready",
        },
      },
      {
        Image:
          "https://amityonline.com/_s/icon1_1_cce90be440_a19e6681c3.webp",
        Title: { text: "Diverse Learning \nMediums" },
        Subtitle: {
          text: "E-books, printed & audio books, videos to cater your preferences & unique learning style",
        },
      },
      {
        Image: "https://amityonline.com/_s/Offline_Experiences_a70f234f95_55a8360954.webp",
        Title: { text: "Offline\nExperiences" },
        Subtitle: {
          text: "Weave a close bond with faculty & peers, via on campus orientation programs and activities",
        },
      },
      {
        Image: "https://amityonline.com/_s/besocial_1_a643e1a51e_bc03b95249.webp",
        Title: { text: "beSocial - Student \nCommunity\n Platform" },
        Subtitle: {
          text: "Weave a close bond with faculty & peers, via on campus orientation programs and activities",
        },
      },
      {
        Image:
          "https://amityonline.com/_s/Career_Services_b3e90177a9.webp",
        Title: { text: "Career\nServices" },
        Subtitle: {
          text: "Be job-ready with resume building workshops, internships & industry mentorship",
        },
      },
      {
        Image:
          "https://amityonline.com/_s/Doorstepdeliveryofbooks_524db160e1_dc129c6397.webp",
        Title: { text: "Doorstep Delivery\nOf Books" },
        Subtitle: {
          text: "India’s only online university to provide physical books to read at your door step",
        },
      },
      {
        Image:
          "https://amityonline.com/_s/Metaverse_Campus_1604b68cf9_df4a72f56a.webp",
        Title: { text: "Metaverse\nCampus " },
        Subtitle: {
          text: "Discovering endless possibilities of Amity campus through our metaverse tour experience",
        },
      },
    ],
  };

  
  export const WhyChooseAmity = {
    id: "1",
    enabled:true,
    Title: {   
      enabled:true,
      text: "Why Choose Amity Online?" 
    },
    Subtitle: { enabled:true, text: "Be ahead with\nIndustry-first Advantages" },
    ImageList: [
      {
        Image:
          "https://amityonline.com/_s/Industry_Visitsfor_Real_World_Exposure_4d302f06e3.webp",
        Title: { text: "Industry Visits for \n Real-World Exposure" },
        Subtitle: {
          text: "Experience hands-on learning through visits to top industry workplaces",
        },
      },
      {
        Image:
          "https://amityonline.com/_s/Dedicated_Academic_Advisors_12de4fdfc3.webp",
        Title: { text: "Dedicated Academic\nAdvisor" },
        Subtitle: {
          text: "Dedicated experts and advisor to guide you at every step of your professional career",
        },
      },
      {
        Image:
          "https://amityonline.com/_s/AI_Professor_AMI_cdac4f71ed.webp",
        Title: { text: "AI-Professor\nAMI" },
        Subtitle: {
          text: "Powered by Chat-GPT 4 and \nopen AI-driven technology for online learning",
        },
      },
      {
        Image:
          "https://amityonline.com/_s/Placementopportunities_257e9e577a.webp",
        Title: { text: "Placement \nOpportunities" },
        Subtitle: {
          text: "Job interview prepration, placement assistance & resume building for students to be job-ready",
        },
      },
      {
        Image:
          "https://amityonline.com/_s/icon1_1_cce90be440.webp",
        Title: { text: "Diverse Learning Mediums" },
        Subtitle: {
          text: "E-books, printed & audio books, videos to cater your preferences & unique learning style",
        },
      },
      {
        Image: "https://amityonline.com/_s/Offline_Experiences_a70f234f95.webp",
        Title: { text: "Offline\nExperiences" },
        Subtitle: {
          text: "Weave a close bond with faculties & peers, via on campus orientation programs and activities",
        },
      },
      {
        Image: "https://amityonline.com/_s/besocial_1_a643e1a51e.webp",
        Title: { text: "beSocial - Student \nCommunity Platform" },
        Subtitle: {
          text: "Where 75,000+ students connect, engage, and grow",
        },
      },
      {
        Image:
          "https://amityonline.com/_s/Career_Services_b3e90177a9.webp",
        Title: { text: "Career\nServices" },
        Subtitle: {
          text: "Be job-ready with resume building workshops, internships & industry mentorship",
        },
      },
      {
        Image:
          "https://amityonline.com/_s/Doorstepdeliveryofbooks_524db160e1.webp",
        Title: { text: "Doorstep Delivery\nOf Books" },
        Subtitle: {
          text: "India’s only online university to provide physical books to read at your door step",
        },
      },
      {
        Image:
          "https://amityonline.com/_s/Metaverse_Campus_1604b68cf9.webp",
        Title: { text: "Metaverse\nCampus " },
        Subtitle: {
          text: "Discovering endless possibilities of Amity campus through our metaverse tour experience",
        },
      },
    ],
  };

  export const WhyChooseAmityHomePage = {
    id: "1",
    enabled:true,
    Title: {   
      enabled:true,
      text: "Why Say ***Yes*** To ***Amity Online***" 
    },
    Subtitle: { enabled:true, text: "Globally recognised | Digitally advanced | Deeply personalised" },
  };
  
  export const CareerServicesSection = {
      "enabled": true,
      "Title": {
        "enabled": true,
        "text": "Holistic Career Services: How we help you build your dream career"
      },
      "Subtitle": {
        "enabled": true,
        "text": "Our wide range of services are designed to meet your specific needs for career"
      },
      "CTA": {
        "text": "REGISTER NOW",
        "title": "REGISTER NOW TEST",
        "enabled": false
      },
      "ImageList": [
        {
          "enabled": true,
          "Title": "Career exploration tools",
          "Subtitle": "- Assessing your interests and strengths\n- Exploring different career options and pathways\n- Identifying your passion and potential",
          "Image": {
            "data": {
              "attributes": {
                "url": "https://amityonline.com/_s/image_10134_d8c4e7eb2f_bdbadeccfb.webp",
                "alternativeText": null
              }
            }
          }
        },
        {
          "enabled": true,
          "Title": "Resume/CV assistance",
          "Subtitle": "- Crafting professional resumes and CVs\n- Customizing application  for specific industries\n- Highlighting your skills and achievements effectively",
          "Image": {
            "data": {
              "attributes": {
                "url": "https://amityonline.com/_s/image_10135_6040bd8742_48391742c0.webp",
                "alternativeText": null
              }
            }
          }
        },
        {
          "enabled": true,
          "Title": "Virtual job search support",
          "Subtitle": "- Guiding through the online application process\n- Networking support via virtual events and platforms\n- Preparing for virtual interviews to establish a professional online presence",
          "Image": {
            "data": {
              "attributes": {
                "url": "https://amityonline.com/_s/image_10136_ec714781ff_c2aa81da6b.webp",
                "alternativeText": null
              }
            }
          }
        },
        {
          "enabled": true,
          "Title": "Career counselling & advising",
          "Subtitle": "- 1-on-1 sessions with experienced counsellors\n- Personalized career assessments and goal setting\n- Guidance on making informed decisions",
          "Image": {
            "data": {
              "attributes": {
                "url": "https://amityonline.com/_s/image_10137_4d740ef08a_01c1a85249.webp",
                "alternativeText": null
              }
            }
          }
        }
      ]
  }
  
  export const Faculties = {
      "data": [
          {
          "id": "1",
          "attributes": {
              "Name": "Dr. Coral Jasmine Barboza",
              "enabled": true,
              "ShortDesc": "Dr. Barboza, a dedicated educator, specializes in General, HR, Strategic, Marketing Management, and Organisational Behaviour at graduate and postgraduate levels. Her research focuses on AI's impact on HR practices, disruptive innovation, digital transformation, leadership, and Smart Cities development.",
              "Department": "Associate Professor",
              "Designation": "10+ years of experience; PhD in General Management",
              "BorderColor": "#FF3E6C",
              "image": "https://amityonline.com/_s/Coral_Barboza_431bdc3292.webp"
          }
          },
          {
          "id": "2",
          "attributes": {
              "Name": "Dr. Rashmi Saxena",
              "enabled": true,
              "ShortDesc": "Dr. Rashmi Saxena, Assistant Professor with 14 years of academic and corporate experience, holds a Ph.D. in Management (Insurance) and an MBA in Marketing and Finance. She blends theory with practical insights, encouraging active participation, critical thinking, and skill-building to prepare students as future-ready professionals.",
              "Department": "Assistant Professor",
              "Designation": "14+ years of experience; PhD in Management",
              "BorderColor": "#5DCA7B",
              "image": "https://amityonline.com/_s/Rashmi_8b49fa929f_0da32a8dc8.webp"
          }
          },
          {
            "id": "3",
            "attributes": {
                "Name": "Mona Chaudhary",
                "enabled": true,
                "ShortDesc": "Ms. Mona Chaudhary, Assistant Professor with 9+ years of teaching experience, holds a B.Com (Hons), MBA, Diploma in Labour Laws, and HR Analytics certification. Pursuing a PhD in Management, her research focuses on online education in India. She teaches HRM, OB, Labour Laws, and Management, and has presented papers at key conferences.",
                "Department": "Assistant Professor",
                "Designation": "9+ years of experience; MBA ",
                "BorderColor": "#5DCA7B",
                "image": "https://amityonline.com/_sb/Mona_a759d1ef3c.webp"
            }
          },
          {
            "id": "4",
            "attributes": {
                "Name": "Neha Tandon ",
                "enabled": true,
                "ShortDesc": "Neha Tandon is an Assistant Professor at Amity University, Noida,with over 3 years of experience in this role. She has a strong background in International Business, Accounting, Managerial Finance, and content creation for e-learning. Neha has also worked as an Assistant Professor at the Institute of Management Studies,Noida. She holds an MBA in Finance from Guru Gobind Singh Indraprastha University and a B.Sc. (Honors) from Delhi University.",
                "Department": "Assistant Professor",
                "Designation": "10+ years of experience; Double PG in Management & Commerce",
                "BorderColor": "#4194F4",
                "image": "https://amityonline.com/_sb/Neha_863217fa3c.webp"
            }
            },
          {
            "id": "5",
            "attributes": {
                "Name": "Dr. Pragati Sahai",
                "enabled": true,
                "ShortDesc": "Dr. Pragati Sahai has 17 years of teaching and research experience at prominent institutions. Holding an M.Phil and Ph.D. in Biotechnology, she is a founding faculty member of the Biotechnology Department. Dr. Sahai has 24 publications in top Scopus-indexed journals and expertise in environmental sustainability, organizational ethics, and workplace social skill development.",
                "Department": "Assistant Professor",
                "Designation": "17+ years of experience; PhD in Biotechnology",
                "BorderColor": "#5DCA7B",
                "image": "https://amityonline.com/_sb/Pragati_baf7c9d3f8.webp"
            }
          },
          {
            "id": "6",
            "attributes": {
                "Name": "Dr. Harshita",
                "enabled": true,
                "ShortDesc": "Dr. Harshita Singh specializes in SHRM, industrial relations, labor laws, and green HRM. She has published case studies in Richard Ivey and numerous research papers in top journals. With extensive experience in training and research workshops, she has earned accolades, including best paper awards at XLRI.",
                "Department": "Assistant Professor",
                "Designation": "3+ years of experience; PhD in SHRM",
                "BorderColor": "#FF3E6C",
                "image": "https://amityonline.com/_sb/Harshita_23cfd4750d.webp"
            }
          },
          {
            "id": "7",
            "attributes": {
                "Name": "Dr. Maitri Savarn",
                "enabled": true,
                "ShortDesc": "Dr. Maitri, with 22 years of experience , holds a PhD & PG  in Human Resource Management . She has served as an  Associate Professor,Professor, HoD, and Chair Head at college & University Level. She lead  NAAC, NBA accreditation and contributed to AICTE’s SLAP project. She was honored with the Best Faculty Award. She also qualified the ARPIT Exam.She has founded,mentored & led different clubs & committees. Presented & Authored Papers,Chapters  in National & International Conferences & Journals.She has developed Attribute Assessment Inventory (TAAI), a psychometric tool.She has multiple postgraduates in Mass Communication, Psychology, Labour Welfare,Eng Lit and more.",
                "Department": "Professor ",
                "Designation": "22+ years of experience; PhD in Human Resource Management",
                "BorderColor": "#FF3E6C",
                "image": "https://amityonline.com/_sb/Maitri_222f683f53.webp"
            }
          }
      ]
  }
  export const NewFaculties = {
    "data": [
        {
        "id": "1",
        "attributes": {
            "Name": "Dr. Ashmita Rupal",
            "enabled": true,
            "ShortDesc": "Ashmita Rupal is a civil engineer with a master's in Construction Technology and Management and a Ph.D. from NITTTR Chandigarh. With over five years of experience across academia and the construction industry, her expertise spans construction management, ",
            "Department": "Assistant Professor",
            "Designation": "RICS School of Built Environment, Amity University, Noida",
            "BorderColor": "#FF3E6C",
            "image": "https://amityonline.com/_sb/Ashmita_Rupal_eeabc1e558.png"
        }
        },
        {
        "id": "2",
        "attributes": {
            "Name": "Dr. Jyoti Singh",
            "enabled": true,
            "ShortDesc": "Dr. Jyoti Singh is a BIM and Digital Technology expert with over 8 years in construction management and 2.5 years in academia. She has held roles at Appalachian State University and the University of Florida, and consulted for bimSCORE Ltd. A PhD from HKU",
            "Department": "Assistant Professor",
            "Designation": "RICS School of Built Environment, Amity University, Noida",
            "BorderColor": "#5DCA7B",
            "image": "https://amityonline.com/_sb/JS_Headshot_1472db14a4.png"
        }
        },
        {
          "id": "3",
          "attributes": {
              "Name": "Triveni Prasad Nanda",
              "enabled": true,
              "ShortDesc": "Triveni Prasad Nanda is an architect by education with comprehensive experience across the built environment. His expertise spans project feasibility, design and development, construction execution, project management, and contract administration. A resul",
              "Department": "Assistant Professor",
              "Designation": "RICS School of Built Environment, Amity University, Noida",
              "BorderColor": "#5DCA7B",
              "image": "https://amityonline.com/_sb/triveni_nanda_3ae2c78f89.png"
          }
        },
        {
          "id": "4",
          "attributes": {
              "Name": "Mohd. Suhail Khan",
              "enabled": true,
              "ShortDesc": "Mohd. Suhail Khan is an Assistant Professor at the School of Construction with over 7 years of combined industry and academic experience. A civil engineer by qualification, he specializes in Construction Technology and Management. He is currently pursuing",
              "Department": "Assistant Professor",
              "Designation": " RICS School of Built Environment, Amity University, Noida",
              "BorderColor": "#4194F4",
              "image": "https://amityonline.com/_sb/Mohd_suhail_khan_c51c7ee8ee.png"
          }
          },
    ]
}
export const bundleFacilties = {
  "data": [
    {
      "id": "1",
      "attributes": {
          "Name": "Dr Sunil Kumar",
          "enabled": true,
          "ShortDesc": "Hello, I'm Dr. Sunil Kumar, a PhD holder in Management as well as an engineer. I'm your faculty at Amity University, where I specialize in management courses such as research and production operation management.",
          "Department": "Assistant Professor",
          "Designation": "10+ years of experience; P.hD. in Management",
          "BorderColor": "#4194F4",
          "image": "https://amityonline.com/_s/sunil_kumar_35e3366dd3.webp"
      }
      },
      {
        "id": "2",
        "attributes": {
            "Name": "Neha Tandon",
            "enabled": true,
            "ShortDesc": "Hello, I'm Dr. Sunil Kumar, a PhD holder in Management as well as an engineer. I'm your faculty at Amity University, where I specialize in management courses such as research and production operation management.",
            "Department": "Assistant Professor",
            "Designation": "8+ years of experience; Double PG in Management & Commerce",
            "BorderColor": "#4194F4",
            "image": "https://amityonline.com/_s/neha_tandon_71af2c647e.webp"
        }
        },
        {
          "id": "3",
          "attributes": {
              "Name": "Sachit Paliwal",
              "enabled": true,
              "ShortDesc": "Hello, my name is Sachit Paliwal. I work as an Assistant Professor and Program Coordinator of BCom at Amity University Online. My area of specialization is finance and accounting, and my research includes stock market integration, portfolio analysis. ",
              "Department": "Assistant Professor",
              "Designation": "12+ years of experience; MBA in Finance Management",
              "BorderColor": "#4194F4",
              "image": " https://amityonline.com/_s/sachit_paliwal_ae4bf7ed73.webp"
          }
          },
      {
      "id": "4",
      "attributes": {
          "Name": "Pranab Das",
          "enabled": true,
          "ShortDesc": "Pranab is part of the Business Excellence practice at KPMG India, delivering Data Analytics solutions and advanced courses in AI, ML, and Visualization. He has worked on projects across Text, Marketing, Financial, and HR Analytics, and is proficient in Py",
          "Department": "Consultant Advisory-Transformation-BE",
          "Designation": "KPMG India",
          "BorderColor": "#FF3E6C",
          "image": "https://amityonline.com/_sb/PRANAB_245916db13.webp"
      }
      },
      {
      "id": "5",
      "attributes": {
          "Name": "Kaushik Swaroop",
          "enabled": true,
          "ShortDesc": "Kaushik is part of KPMG India’s Business Excellence practice, specializing in data analytics, machine learning, AI, and data visualization. His project work includes text, marketing, financial, and HR analytics. He is proficient in Python, Tableau, and SQ",
          "Department": "Consultant Advisory-Transformation-BE",
          "Designation": "KPMG India",
          "BorderColor": "#5DCA7B",
          "image": "https://amityonline.com/_sb/Kaushik_Swaroop_148ab72beb.png"
      }
      },
      {
        "id": "6",
        "attributes": {
            "Name": "Jagadish GS",
            "enabled": true,
            "ShortDesc": "Jagdish is part of KPMG India’s Business Excellence practice, delivering Data Analytics solutions and training in areas like Machine Learning, Python, Text Analytics, and Data Visualization using Python, Tableau, and Power BI. He has hands-on experience i",
            "Department": "Analyst, Advisory ",
            "Designation": "KPMG India",
            "BorderColor": "#5DCA7B",
            "image": "https://amityonline.com/_sb/Jagadish_GS_8428a5a4a1.webp"
        }
      },
      
         
  ]
}
  
  export const MeetFacultySection = {
      "enabled": true,
      "Title": {
        "text": "Meet our top-ranked faculty",
        "enabled": true
      },
      "SubTitle": {
        "text": "Learn from the best at Amity Online with World-Class education and leading International Faculty",
        "enabled": true
      }
    }
  
    export const Testimonials = [
      {
        name: "Dr Vanita Ahuja",
        title: "",
        image: "https://amityonline.com/_s/DR_VANITA_AHUJA_bfa8465795.webp",
        video: "https://amityonline.com/_s/Dr_Vanita_f51cbe119a.mp4",
      },
      {
        name: " Dr. Ashmita Rupal",
        title: " Assistant Professor, Coordinator-online MBA CPM, RICS School of Built Environment,AUUP.",
        image: "https://amityonline.com/_s/DR_ASHMITA_RUPAL_f91a4ddc63.webp",
        video: "https://amityonline.com/_s/Dr_Ashmita_771637cbb3.mp4",
      },
      {
        name: "Dr. Jyoti Singh",
        title: "",
        image: "https://amityonline.com/_s/DR_JYOTI_SINGH_07c265d503.webp",
        video: "https://amityonline.com/_s/Dr_Jyoti_37e4b6c6cb.mp4",
      },
      {
        name: "Triveni Prasad Nanda",
        title: "Assistant Professor, RICS School of Built Environment,AUUP.",
        image: "https://amityonline.com/_s/TRIVENI_PRASAD_NANADA_83c33afe2a.webp",
        video: "https://amityonline.com/_s/Triveni_Prasad_Nanada_b00da14eec.mp4",
      },
      {
        name: "Tanya Luthra",
        title: "B.com (Hons.), Student",
        image: "https://amityonline.com/_s/Tanya+Luthra.jpg",
        video: "https://amityonline.com/_s/Tanya+Luthra.mp4",
      },
      {
        name: "Shalu Sharma",
        title: "MAJMC, Student",
        image: "https://amityonline.com/_s/Shalu+Sharma.jpg",
        video: "https://amityonline.com/_s/Shalu+Sharma.mp4",
      },
      {
        name: "Anushka Pathak",
        title: "MBA, Student",
        image: "https://amityonline.com/_s/Anushka+Pathak.jpg",
        video: "https://amityonline.com/_s/Anushka+Pathak.mp4",
      },
    ];
    export const TestimonialsStudent=[
      {
        name: "Ruchir",
        title: "BBA, Student",
        image: "https://amityonline.com/_s/test1_ad71c3ef33.webp",
        video: "https://amityonline.com/_s/Ruchir_943cd604e9.mp4",
      },
      {
        name: "Priyanka Shreshtha",
        title: "BBA, Student",
        image: "https://amityonline.com/_s/test2_7a0ba6153d.webp",
        video: "https://amityonline.com/_s/videoplayback_2_5de64578d2.mp4",
      },
      {
        name: "Abhik Ganguly",
        title: "MBA, Student",
        image: "https://amityonline.com/_s/4_copy_77ca6db522.webp",
        video: "https://amityonline.com/_s/Abhik_Ganguly_MBA_7a2039ef1b.mp4",
      },
      {
        name: "Ridhima Rai",
        title: "BBA, Student",
        image: "https://amityonline.com/_s/2_b5dc53274c.webp",
        video: "https://amityonline.com/_s/videoplayback_3_27f407a07d.mp4",
      }, 
      {
        name: "Tanya Luthra",
        title: "B.com (Hons.), Student",
        image: "https://amityonline.com/_s/Tanya+Luthra.jpg",
        video: "https://amityonline.com/_s/Tanya+Luthra.mp4",
      },
      {
        name: "Shalu Sharma",
        title: "MAJMC, Student",
        image: "https://amityonline.com/_s/Shalu+Sharma.jpg",
        video: "https://amityonline.com/_s/Shalu+Sharma.mp4",
      },
      {
        name: "Anushka Pathak",
        title: "MBA, Student",
        image: "https://amityonline.com/_s/Anushka+Pathak.jpg",
        video: "https://amityonline.com/_s/Anushka+Pathak.mp4",
      },
    ]
  
  export const BrandIcons = [
  "https://amityonline.com/_s/google_8d1607e744.webp",
  "https://amityonline.com/_s/cognizant_178ac0c0e8.webp",
  "https://amityonline.com/_s/techmahindra_19d14d057c.webp",
  "https://amityonline.com/_s/tcs_b180d19fed.webp",
  "https://amityonline.com/_s/cisco_edf05f0d9f.webp",
  "https://amityonline.com/_s/maxlife_1dcc421e31.webp",
  "https://amityonline.com/_s/mahindra_group_fa1f63920b.webp",
  "https://amityonline.com/_s/vedanta_ed809f3f19.webp",
  "https://amityonline.com/_s/Vi_logo_19648b8c97.webp",
  "https://amityonline.com/_s/dhl_46ec4d1739.webp",
  "https://amityonline.com/_s/accenture_d490867c33.webp",
  "https://amityonline.com/_s/capgemini_4d8b3960ad.webp",
  "https://amityonline.com/_s/wipro_f1853361f8.webp",
  "https://amityonline.com/_s/l_and_t_infotech_688414cfb7.webp",
  "https://amityonline.com/_s/hitachi_vantara_0a8ee1226d.webp",
  "https://amityonline.com/_s/hdfc_ccdfd895c0.webp",
  "https://amityonline.com/_s/aditya_birla_group_7d22445969.webp",
  "https://amityonline.com/_s/siemens_dd5c93dc60.webp",
  "https://amityonline.com/_s/hindustan_unilever_3647009914.webp",
  "https://amityonline.com/_s/Happiest_Minds_2ea40da7d2.webp",
  "https://amityonline.com/_s/amazon_2a272c1815.webp",
  "https://amityonline.com/_s/hcltech_4cfe467632.webp",
  "https://amityonline.com/_s/infosys_6092918d2e.webp",
  "https://amityonline.com/_s/ernst_young_8ca6db28b6.webp",
  "https://amityonline.com/_s/flipkart_4dc23e5fb3.webp",
  "https://amityonline.com/_s/ICICI_Bank_3bae397133.webp",
  "https://amityonline.com/_s/jp_morgan_3cfc3d07c4.webp",
  "https://amityonline.com/_s/kpmg_aa7855b7a7.webp",
  "https://amityonline.com/_s/hero_befb19f4ad.webp",
  "https://amityonline.com/_s/tata_steel_677a0fa539.webp",
  ];

  export const BrandIconsJSON = [
    {
      src: "https://amityonline.com/_s/google_855c99de43.webp",
      alt: "Google Logo",
      title: "Google"
    },
    {
      src: "https://amityonline.com/_s/apple_e6c370def7.webp",
      alt: "Apple Logo",
      title: "Apple"
    },
    {
      src: "https://amityonline.com/_s/pwc_a1ecc8548f.webp",
      alt: "PWC Logo",
      title: "PWC"
    },
    {
      src: "https://amityonline.com/_s/reliance_industries_limited_2baf8ef73a.webp",
      alt: "Reliance Logo",
      title: "Reliance"
    },
    {
      src: "https://amityonline.com/_s/ernst_young_486f8547bd.webp",
      alt: "EY Logo",
      title: "Ernest Young"
    },
    {
      src: "https://amityonline.com/_s/samsung_fc88911e0c.webp",
      alt: "Samsung Logo",
      title: "Samsung"
    },
    {
      src: "https://amityonline.com/_s/qatar_airways_2f68f618ab.webp",
      alt: "Qatar Logo",
      title: "Qatar"
    },
    {
      src: "https://amityonline.com/_s/techmahindra_14d9b4f362.webp",
      alt: "Tech Mahindra Logo",
      title: "Tech Mahindra"
    },
    {
      src: "https://amityonline.com/_s/sbi_47818db2e9.webp",
      alt: "SBI",
      title: "SBI"
    },
    {
      src: "https://amityonline.com/_s/hdfc_75e1e13a82.webp",
      alt: "HDFC Logo",
      title: "HDFC"
    },
    {
      src: "https://amityonline.com/_s/vedanta_863a2b0624.webp",
      alt: "Vedanta",
      title: "Vedanta"
    },
    {
      src: "https://amityonline.com/_s/cipla_725cdcb38f.webp",
      alt: "Cipla",
      title: "Cipla"
    },
    {
      src: "https://amityonline.com/_s/capgemini_2ceffeb45b.webp",
      alt: "Capgemini Logo",
      title: "Capgemini"
    },
    {
      src: "https://amityonline.com/_s/axis_bank_9c7936ad0f.webp",
      alt: "Axis Bank Logo",
      title: "Axis Bank"
    },
    {
      src: "https://amityonline.com/_s/dbs_9fda93ca94.webp",
      alt: "DBS",
      title: "DBS"
    },
    {
      src: "https://amityonline.com/_s/grant_thronton_6bb45f0851.webp",
      alt: "Grant Thornton Logo",
      title: "Grant Thornton"
    },
    {
      src: "https://amityonline.com/_s/tata_1mg_758c9371f0.webp",
      alt: "1mg Logo",
      title: "Tata 1mg"
    },
    {
      src: "https://amityonline.com/_s/amazon_ad97400ada.webp",
      alt: "Amazon Logo",
      title: "Amazon"
    },
    {
      src: "https://amityonline.com/_s/hcltech_6a6ebb4cc2.webp",
      alt: "HCLTech Logo",
      title: "HCLTech"
    },
    {
      src: "https://amityonline.com/_s/wipro_77b7c2de0a.webp",
      alt: "Wipro Logo",
      title: "Wipro"
    },
    {
      src: "https://amityonline.com/_s/kpmg_15b04c4131.webp",
      alt: "KPMG Logo",
      title: "KPMG"
    },
    {
      src: "https://amityonline.com/_s/aditya_birla_group_a31995c61d.webp",
      alt: "Aditya Birla Logo",
      title: "Aditya Birla"
    },
    {
      src: "https://amityonline.com/_s/dell_technologies_e252013d7c.webp",
      alt: "Dell Technologies Logo",
      title: "Dell Technologies"
    },
    {
      src: "https://amityonline.com/_s/gail_a1476f2959.webp",
      alt: "GAIL Logo",
      title: "GAIL"
    },
    {
      src: "https://amityonline.com/_s/tcs_31bbcf8b23.webp",
      alt: "TCS",
      title: "TCS"
    },
    {
      src: "https://amityonline.com/_s/cognizant_80767f58fd.webp",
      alt: "Cognizant Logo",
      title: "Cognizant"
    },
    {
      src: "https://amityonline.com/_s/ICICI_Bank_de613e29ba.webp",
      alt: "ICICI Logo",
      title: "ICICI"
    },
    {
      src: "https://amityonline.com/_s/tata_steel_1edb2f9fe4.webp",
      alt: "Tata Steel Logo",
      title: "Tata Steel"
    },
    {
      src: "https://amityonline.com/_s/dhl_f14f8df4e5.webp",
      alt: "DHL Logo",
      title: "DHL"
    },
    {
      src: "https://amityonline.com/_s/l_and_t_infotech_42a3295b55.webp",
      alt: "LTI Logo",
      title: "LTI"
    },
    {
      src: "https://amityonline.com/_s/bank_0f_baroda_0fd61be7e1.webp",
      alt: "Bank of Baroda Logo",
      title: "Bank of Baroda"
    },
    {
      src: "https://amityonline.com/_s/delhivery_21f59d3bcf.webp",
      alt: "Delhivery Logo",
      title: "Delhivery"
    },
    {
      src: "https://amityonline.com/_s/car_dekho_104208a0e7.webp",
      alt: "Car Dekho Logo",
      title: "Car Dekho"
    },
    {
      src: "https://amityonline.com/_s/t_series_cf4aa255cb.webp",
      alt: "T Series Logo",
      title: "T Series"
    },
    {
      src: "https://amityonline.com/_s/hindustan_unilever_ef69b24b71.webp",
      alt: "Hindustan Unilever Logo",
      title: "Hindustan Unilever"
    },
    {
      src: "https://amityonline.com/_s/jp_morgan_8d4586ce0d.webp",
      alt: "J.P.Morgan Logo",
      title: "J.P.Morgan"
    },
    {
      src: "https://amityonline.com/_s/infosys_154feeaa4e.webp",
      alt: "Infosys Logo",
      title: "Infosys"
    },
    {
      src: "https://amityonline.com/_s/accenture_4228edf2ec.webp",
      alt: "Accenture Logo",
      title: "Accenture"
    },
    {
      src: "https://amityonline.com/_s/flipkart_e577197fe3.webp",
      alt: "FlipKart Logo",
      title: "FlipKart"
    },
    {
      src: "https://amityonline.com/_s/barclay_766b322011.webp",
      alt: "Barclays Logo",
      title: "Barclays"
    },
    {
      src: "https://amityonline.com/_s/siemens_9a2af15e99.webp",
      alt: "Siemens Logo",
      title: "Siemens"
    },
    {
      src: "https://amityonline.com/_s/cisco_fa28552a73.webp",
      alt: "Cisco Logo",
      title: "Cisco"
    },
    {
      src: "https://amityonline.com/_s/Vi_log_9faa518967.webp",
      alt: "Vi Logo",
      title: "Vi"
    },
    {
      src: "https://amityonline.com/_s/mahindra_group_5153634c9b.webp",
      alt: "Mahindra Logo",
      title: "Mahindra"
    },
    {
      src: "https://amityonline.com/_s/tata_power_4562440574.webp",
      alt: "Tata Power Logo",
      title: "Tata Power"
    },
    {
      src: "https://amityonline.com/_s/iffco_tokio_ba0ca0e2fd.webp",
      alt: "Iffco Tokio Logo",
      title: "Iffco Tokio"
    },
    {
      src: "https://amityonline.com/_s/hero_8069edb396.webp",
      alt: "Hero Logo",
      title: "Hero"
    },
    {
      src: "https://amityonline.com/_s/hsbc_480ab4c6d0.webp",
      alt: "HSBC Logo",
      title: "HSBC"
    },
    {
      src: "https://amityonline.com/_s/federal_bank_cb688f0f4c.webp",
      alt: "Federal Bank Logo",
      title: "Federal Bank"
    },
    {
      src: "https://amityonline.com/_s/maxlife_6370f12cf8.webp",
      alt: "Max Life Logo",
      title: "Max Life"
    },
    {
      src: "https://amityonline.com/_s/hitachi_vantara_4f43434588.webp",
      alt: "Hitachi Vantara Logo",
      title: "Hitachi Vantara"
    },
  ];

  export const BrandIconsJSONNew=[
    {
      src: "https://amityonline.com/_s/cushman_wakefield_1_8ba9623395.webp",
      alt: "cushman_wakefield Logo",
      title: "cushman_wakefield"
    },
    {
      src: "https://amityonline.com/_s/lodha_group_29a779a6ba.webp",
      alt: "Lodha Logo",
      title: "Lodha"
    },
    {
      src: "https://amityonline.com/_s/KPMG_logo_30dac9dd39.webp",
      alt: "KPMG Logo",
      title: "KPMG"
    },
    {
      src: "https://amityonline.com/_s/mahindra_logo_new_horizontal_scaled_f8bf41c0f0.webp",
      alt: "Mahindra Logo",
      title: "Mahindra"
    }, {
      src: "https://amityonline.com/_s/tata_housing_1d6c055186.webp",
      alt: "TATA Logo",
      title: "Tata"
    },
    {
      src: "https://amityonline.com/_s/Duff_and_Phelps_1_b77bc264ee.webp",
      alt: "Duff And Phelps Logo",
      title: "Duff And Phelps"
    },
    {
      src: "https://amityonline.com/_s/prestige_17a65f0e43.webp",
      alt: "Duff And Phelps Logo",
      title: "Duff And Phelps"
    },
    {
      src: "https://amityonline.com/_s/Atkins_logo_16a01e8126.webp",
      alt: "Atkins Logo",
      title: "Atkins"
    },
    {
      src: "https://amityonline.com/_s/dlf_9f6ce1e44d.webp",
      alt: "DLF Logo",
      title: "DLF"
    },
    {
      src: "https://amityonline.com/_s/shapoorji_3ca72a7671.webp",
      alt: "Shapoori Logo",
      title: "Shapoorji PAllonji "
    },
    {
      src: "https://amityonline.com/_s/egis_vector_logo_791d08f335.webp",
      alt: "Egi Logo",
      title: "Egis"
    },
    {
      src: "https://amityonline.com/_s/Savills_logo_ed4eaa6afe.webp",
      alt: "Savills Logo",
      title: "Savills"
    },
    {
      src: "https://amityonline.com/_s/JLL_logo_bf766cf0b4.webp",
      alt: "JLL Logo",
      title: "JLL"
    },
    {
      src: "https://amityonline.com/_s/Tata_realty_1726f67c66.webp",
      alt: "TataReality Logo",
      title: "TataReality"
    },
    {
      src: "https://amityonline.com/_s/20240911144011_b1d5c2cfa5.webp",
      alt: "Vestian Logo",
      title: "Vestian"
    },
    {
      src:"https://amityonline.com/_s/gmr_1c3d47af85.webp",
      alt: "GAAR Logo",
      title: "GAAR"
    },
    {
      src:"https://amityonline.com/_s/Tata_TCE_9dc0c007e5.webp",
      alt: "TCE Logo",
      title: "TCE"
    },
    {
      src:"https://amityonline.com/_s/colt_547b17cb9b.webp",
      alt: "COLT Logo",
      title: "COLT"
    },
    {
      src:"https://amityonline.com/_s/godrej_properties_7c719070b7.webp",
      alt: "Godrej Logo",
      title: "Godrej"
    },
    {
      src:"https://amityonline.com/_s/tnt_group_0f8d29c86f.webp",
      alt: "T&T Logo",
      title: "T&T"
    },
    {
      src:"https://amityonline.com/_s/Colliers_logo_985477166c.webp",
      alt: "COLLIERS Logo",
      title: "COLLIERS"
    },
    {
      src:"https://amityonline.com/_s/Mace_Group_logo_fabc90a453.webp",
      alt: "MACE Logo",
      title: "MACE"
    },
    {
      src:"https://amityonline.com/_s/tekla_logo_d0e550c982.webp",
      alt: "TEKLA Logo",
      title: "TEKLA"
    },
    {
      src:"https://amityonline.com/_s/tm2u2jycwly1o4pwhgvx_42699ba05d.webp",
      alt: "JWL Logo",
      title: "JWL"
    },
    {
      src:"https://amityonline.com/_s/cbre_f29ba70dc1.webp",
      alt: "CBRE Logo",
      title: "CBRE"
    },
    {
      src:"https://amityonline.com/_s/Manjeera_Group_69f5705656.webp",
      alt: "Manjeera Logo",
      title: "Manjeera"
    },
    {
      src:"https://amityonline.com/_s/rustomjee_c6869504ac.webp",
      alt:"Rustomjee Logo",
      title: "Rustomjee"
    },
    {
      src:"https://amityonline.com/_s/livspace_new_347a71e56b.webp",
      alt:"LivSpace Logo",
      title: "LivSpace"
    },
    {
      src:"https://amityonline.com/_s/vconstruct_logo_c0a14fc225.webp",
      alt:"VCONS Logo",
      title: "VCONS"
    },

  ]
  
  export const AttractionCards = [
    {
      fliptext: "Unlock the best scholarship options available for you.",
      Title: {
        text: "Attractive <br /> Scholarships",
        enabled: true,
        ckrich: "",
      },
      Content: {
        text: "<u>Explore Now</u>",
        enabled: true,
      },
      BGColor: "#FFC907",
      TextColor: "#1A325D",
      isOutline: false,
      fontSizeTitle: null,
      fontSizeDescription: null,
      enabled: true,
      titleDescription: null,
    },
    {
      fliptext: "Join us and become part of an institution with decades of global excellence.",
      Title: {
        text: "30+",
        enabled: true,
        ckrich: "",
      },
      Content: {
        text: "Years Of Excellence",
        enabled: true,
      },
      Icon: {
        enabled: true,
        source: {
          data: [
            {
              attributes: {
                alternativeText: null,
                url: "https://amityonline.com/_sb/icon2_56fb744843_670507b84f.webp",
                width: 103,
                height: 177,
              },
            },
          ],
        },
      },
      BGColor: "#FF3E6C",
      TextColor: "#ffffff",
      isOutline: false,
      fontSizeTitle: null,
      fontSizeDescription: null,
      enabled: true,
      titleDescription: null,
    },
    {
      fliptext: "Give direction to your goals with best programs and specialisations in the industry.",
      Title: {
        text: "60+",
        enabled: true,
        ckrich: null,
      },
      Content: {
        text: "Programs & Specializations",
        enabled: true,
      },
      Icon: {
        enabled: true,
        source: {
          data: [
            {
              attributes: {
                alternativeText: null,
                url: "https://amityonline.com/_sb/Group_48100166_fde5ccb563_64b8e2bea7.webp",
                width: 103,
                height: 117,
              },
            },
          ],
        },
      },
      BGColor: "#4A9C61",
      TextColor: "#ffffff",
      isOutline: false,
      fontSizeTitle: null,
      fontSizeDescription: null,
      enabled: true,
      titleDescription: null,
    },
    {
      fliptext: "1,60,000+ students have trusted us for quality education and flexible learning experience.",
      Title: {
        text: "1,60,000+",
        enabled: true,
        ckrich: null,
      },
      Content: {
        text: "Learners' First Choice",
        enabled: true,
      },
      Icon: {
        enabled: true,
        source: {
          data: [
            {
              attributes: {
                alternativeText: null,
                url: "https://amityonline.com/_sb/icon3_f57565e840_9506d36cf9.webp",
                width: 143,
                height: 176,
              },
            },
          ],
        },
      },
      BGColor: "#4194F4",
      TextColor: "#ffffff",
      isOutline: false,
      fontSizeTitle: null,
      fontSizeDescription: null,
      enabled: true,
      titleDescription: null,
    },
  ];

export const StripTextUI =  {
  "enabled": true,
  "stripTextHTML": `<div>
    <span style="font-weight: bold; font-family: ui-sans-serif, system-ui !important; font-size: 14px; text-transform: none; font-weight: bold;">July’25 Session Admissions Open </span>
  </div>`,
  "mStripTextHTML" : `<div>
    <span style="font-weight: bold; font-family: ui-sans-serif, system-ui !important; font-size: 14px; text-transform: none; font-weight: bold;">July’25 Session Admissions Open </span>
  </div>`,
  "lastRegistrationDate" : ""
}

export const ProgramsData = {
  DegreePrograms : {
    "enabled": true,
    "Title": {
      "text": "Explore our online degree programs",
      "enabled": true
    },
    "SubTitle": {
      "enabled": true,
      "text": "Discover our online UG & PG degree programs and begin an exciting educational journey"
    },
    "CTA": {
      "enabled": true,
      "text": "View all",
      "url": "/programs",
      "target": [
        "_self"
      ],
      "title": "View all"
    }
  },
  Programs : {
    data : [
      {
        "attributes": {
          "BasicDetails": {
            "Heading": "Master of Business Administration",
            "enabled": true,
            "url_key": "/master-of-business-administration-online",
            "ProgramType": "PG_Program",
            "CardActionBGColor": "#FFC907",
            "Title1": "QS",
            "Title2": "RANKED",
            "CourseStripText": "QS Ranked",
            "YearsIcon": {
              "title": "years",
              "source": {
                "data": [
                  {
                    "attributes": {
                      "alternativeText": null,
                      "url": "https://amityonline.com/_s/years_40683bcf2d_5d79dc2c4d.svg",
                      "width": 45,
                      "height": 49
                    }
                  }
                ]
              }
            },
            "Image": {
              "source": {
                "data": [
                  {
                    "attributes": {
                      "url": "https://static.amityonline.com/_s/Master_of_Business_Administration_2b444be7d2.jpg",
                      "alternativeText": null,
                      "width": 454,
                      "height": 432
                    }
                  }
                ]
              }
            }
          }
        }
      },
      {
        "attributes": {
          "BasicDetails": {
            "Heading": "Bachelor of Business Administration",
            "enabled": true,
            "url_key": "/bachelor-of-business-administration-online",
            "ProgramType": "UG_Program",
            "CardActionBGColor": "#FFFFFF",
            "Title1": "TOP UG ",
            "Title2": "PROGRAM",
            "CourseStripText": "Top UG Program",
            "YearsIcon": {
              "title": "years",
              "source": {
                "data": [
                  {
                    "attributes": {
                      "alternativeText": null,
                      "url": "https://amityonline.com/_s/Group_48099786_0e1a8f89e0.png",
                      "width": 45,
                      "height": 49
                    }
                  }
                ]
              }
            },
            "Image": {
              "source": {
                "data": [
                  {
                    "attributes": {
                      "url": "https://static.amityonline.com/_s/Bachelor_of_Business_Administration_d46771c48e.webp",
                      "alternativeText": "BBA Online Mobile",
                      "width": 221,
                      "height": 156
                    }
                  }
                ]
              }
            }
          }
        }
      },
      {
        "attributes": {
          "BasicDetails": {
            "Heading": "Master of Computer Applications",
            "enabled": true,
            "url_key": "/master-of-computer-applications-online",
            "ProgramType": "PG_Program",
            "CardActionBGColor": "#FFC907",
            "Title1": "TOP PG",
            "Title2": "PROGRAM",
            "CourseStripText": null,
            "YearsIcon": {
              "title": "years",
              "source": {
                "data": [
                  {
                    "attributes": {
                      "alternativeText": null,
                      "url": "https://amityonline.com/_s/years_40683bcf2d.svg",
                      "width": 45,
                      "height": 49
                    }
                  }
                ]
              }
            },
            "Image": {
              "source": {
                "data": [
                  {
                    "attributes": {
                      "url": "https://static.amityonline.com/_s/Master_of_Computer_Applications_2a376aee25.jpg",
                      "alternativeText": null,
                      "width": 681,
                      "height": 648
                    }
                  }
                ]
              }
            }
          }
        }
      },
      {
        "attributes": {
          "BasicDetails": {
            "Heading": "Bachelor of Computer Applications",
            "enabled": true,
            "url_key": "/bachelor-of-computer-applications-online",
            "ProgramType": "UG_Program",
            "CardActionBGColor": "#FFC907",
            "Title1": "View Program",
            "Title2": "DETAILS",
            "CourseStripText": null,
            "YearsIcon": {
              "title": "years",
              "source": {
                "data": [
                  {
                    "attributes": {
                      "alternativeText": null,
                      "url": "https://amityonline.com/_s/Group_48099786_0e1a8f89e0.png",
                      "width": 45,
                      "height": 49
                    }
                  }
                ]
              }
            },
            "Image": {
              "source": {
                "data": [
                  {
                    "attributes": {
                      "url": "https://static.amityonline.com/_s/Bachelor_of_Computer_Applications_8dd37b71ed.webp",
                      "alternativeText": null,
                      "width": 681,
                      "height": 648
                    }
                  }
                ]
              }
            }
          }
        }
      }
    ]
  }
} 

export const HomepageFAQs = {
  "FaqType": null,
  "QuestionAnswer": [
    {
      "Answer": "Amity University Online is India's first UGC-approved online university offering globally recognized online undergraduate, postgraduate, and certificate programs. Designed for working professionals and students, the platform provides the flexibility to advance education and careers without compromising existing commitments.",
      "AnswerCK": null,
      "Question": "What is Amity University Online?",
      "QuestionCK": "",
      "Type": "GENERAL",
      "enabled": true,
      "id": "1"
    },
    {
      "Answer": "Once enrolled, students receive login credentials for the student portal. This platform provides access to all learning resources, including live lectures, recorded sessions, e-books, and assignments. AI-Professor AMI is also available 24/7 to assist with academic queries. The learning platform also provides various skill enhancement courses to enhance learners' employability skills.",
      "AnswerCK": null,
      "Question": "How do I access my course?",
      "QuestionCK": null,
      "Type": "ACADEMICS",
      "enabled": true,
      "id": "2"
    },
    {
      "Answer": "Yes, Amity University Online is fully accredited by the University Grants Commission (UGC) and meets global academic standards. It is the only Indian institution offering a QS-ranked online MBA program and also holds accreditations from AICTE and WASC. ",
      "AnswerCK": null,
      "Question": "Is Amity University Online Accredited ?",
      "QuestionCK": null,
      "Type": "GENERAL",
      "enabled": true,
      "id": "3"
    },
    {
      "Answer": "",
      "AnswerCK": `<p>
    <span style=""><span style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:500;letter-spacing:normal;orphans:2;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">Students have access to:</span></span>
</p>
<ul style="-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);box-sizing:border-box;color: #1a1a1a;font-family:Raleway, sans-serif;font-size:13.3333px;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:500;letter-spacing:normal;margin-bottom:1rem;margin-top:0px;orphans:2;padding-left:2rem;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">
    <li style="box-sizing:border-box;color: #1a1a1a;">
        Live and recorded lectures by experienced Indian &amp; global faculty and industry experts.
    </li>
    <li style="box-sizing:border-box;color: #1a1a1a;">
        E-books, physical study materials, and case studies.
    </li>
    <li style="box-sizing:border-box;color: #1a1a1a;">
        Collaborative activities and webinars.
    </li>
</ul>`,
      "Question": " What study resources are available? ",
      "QuestionCK": null,
      "Type": "ACADEMICS",
      "enabled": true,
      "id": "72"
    },
    {
      "Answer": "",
      "AnswerCK": `<p>
    <span style=""><span style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:500;letter-spacing:normal;orphans:2;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">The admission process is simple:</span></span>
</p>
<ul style="-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);box-sizing:border-box;color: #1a1a1a;font-family:Raleway, sans-serif;font-size:13.3333px;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:500;letter-spacing:normal;margin-bottom:1rem;margin-top:0px;orphans:2;padding-left:2rem;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">
    <li style="box-sizing:border-box;color: #1a1a1a;">
        Select your program and complete the online application form.
    </li>
    <li style="box-sizing:border-box;color: #1a1a1a;">
        Upload the required documents and pay the registration fee.
    </li>
    <li style="box-sizing:border-box;color: #1a1a1a;">
        Upon acceptance, confirm your enrollment by making the program fee payment.
    </li>
</ul>
<p>
    <span style=""><span style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:500;letter-spacing:normal;orphans:2;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">The admissions team and AI-Professor AMI are available to assist at every step.</span></span>
</p>`,
      "Question": "What is the admission process?",
      "QuestionCK": null,
      "Type": "ADMISSION",
      "enabled": true,
      "id": "73"
    },
    {
      "Answer": null,
      "AnswerCK": `<p>
    <span style=""><span style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:500;letter-spacing:normal;orphans:2;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">Amity University Online is a leader in online education, offering:</span></span>
</p>
<ul style="-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);box-sizing:border-box;color: #1a1a1a;font-family:Raleway, sans-serif;font-size:13.3333px;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:500;letter-spacing:normal;margin-bottom:1rem;margin-top:0px;orphans:2;padding-left:2rem;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">
    <li style="box-sizing:border-box;color: #1a1a1a;">
        India's first UGC-approved online university programs.
    </li>
    <li style="box-sizing:border-box;color: #1a1a1a;">
        The only QS-ranked online MBA program in India.
    </li>
    <li style="box-sizing:border-box;color: #1a1a1a;">
        Flexible learning schedules with renowned faculty and global networking opportunities.
    </li>
    <li style="box-sizing:border-box;color: #1a1a1a;">
        Comprehensive learning resources, including live sessions, recorded lectures, and interactive content.
    </li>
    <li style="box-sizing:border-box;color: #1a1a1a;">
        AI-Professor AMI, providing 24/7 academic support for doubt resolution and guidance.
    </li>
    <li style="box-sizing:border-box;color: #1a1a1a;">
        <b style="box-sizing:border-box;color: #1a1a1a;font-weight:bolder;"><strong>beSocial</strong></b>, a virtual campus experience with webinars, gamified activities, peer networking, and program-specific channels.
    </li>
    <li style="box-sizing:border-box;color: #1a1a1a;">
        Industry visits for practical exposure, enabling students to connect with professionals and apply theoretical knowledge in real-world settings.
    </li>
</ul>`,
      "Question": "What sets Amity University Online apart?",
      "QuestionCK": null,
      "Type": "GENERAL",
      "enabled": true,
      "id": "74"
    },
    {
      "Answer": "Classes are delivered through live interactive sessions, recorded lectures, and forums for discussions. This hybrid model ensures a flexible yet engaging learning experience. Students can also participate in beSocial for additional collaborative and peer-based learning opportunities.",
      "AnswerCK": null,
      "Question": "How are classes conducted?",
      "QuestionCK": null,
      "Type": "ACADEMICS",
      "enabled": true,
      "id": "76"
    },
    {
      "Answer": "",
      "AnswerCK": `<p>
    <span style=""><span style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:500;letter-spacing:normal;orphans:2;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">Admission requirements vary by program:</span></span>
</p>
<ul style="-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);box-sizing:border-box;color: #1a1a1a;font-family:Raleway, sans-serif;font-size:13.3333px;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:500;letter-spacing:normal;margin-bottom:1rem;margin-top:0px;orphans:2;padding-left:2rem;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">
    <li style="box-sizing:border-box;color: #1a1a1a;">
        For undergraduate programs: Completion of 10+2.
    </li>
    <li style="box-sizing:border-box;color: #1a1a1a;">
        For postgraduate programs: A bachelor's degree is required.
    </li>
    <li style="box-sizing:border-box;color: #1a1a1a;">
        Academic certificates and a valid government-issued ID.
    </li>
    <li style="box-sizing:border-box;color: #1a1a1a;">
        Some programs may require additional eligibility tests.
    </li>
</ul>`,
      "Question": "What are the admission requirements? ",
      "QuestionCK": null,
      "Type": "ADMISSION",
      "enabled": true,
      "id": "77"
    },
    {
      "Answer": "Admissions are conducted twice annually. Updates and deadlines are posted on the official website.",
      "AnswerCK": null,
      "Question": "When are admissions open?",
      "QuestionCK": null,
      "Type": "ADMISSION",
      "enabled": true,
      "id": "78"
    },
    {
      "Answer": "Amity University Online is the online learning platform of Amity University, one of India's leading private universities. It\noffers a wide range of undergraduate, postgraduate, and diploma programs across various disciplines, delivered\nentirely online.\n",
      "AnswerCK": null,
      "Question": "What is Amity University Online?",
      "QuestionCK": null,
      "Type": null,
      "enabled": true,
      "id": "432"
    },
    {
      "Answer": "Exams are conducted in a secure online proctored environment on the student portal. The system uses advanced technology to maintain academic integrity. Assessments also include quizzes, assignments, and hands-on projects, ensuring a comprehensive evaluation. Faculty and AI-Professor AMI are available to support students and help them prepare for exams better.",
      "AnswerCK": null,
      "Question": "How are exams conducted?",
      "QuestionCK": null,
      "Type": "ACADEMICS",
      "enabled": true,
      "id": "433"
    },
    {
      "Answer": "The academic calendar is accessible on the student portal and provides details on assignment deadlines, examination schedules, and other milestones. The student community portal, beSocial, also updates students with reminders about key academic events.",
      "AnswerCK": null,
      "Question": "Where can I find the academic calendar?",
      "QuestionCK": null,
      "Type": "ACADEMICS",
      "enabled": true,
      "id": "434"
    },
    {
      "Answer": "After completing the enrollment process, students receive a confirmation email with login credentials for the E-Campus portal, granting access to learning materials and resources",
      "AnswerCK": null,
      "Question": "How do I confirm my admission?",
      "QuestionCK": null,
      "Type": "ADMISSION",
      "enabled": true,
      "id": "435"
    },
    {
      "Answer": "Yes, admission cancellations are reviewed individually. Refunds, if applicable, are processed as per university policies. The admissions team can assist with cancellation requests.",
      "AnswerCK": null,
      "Question": "Can I cancel my admission?",
      "QuestionCK": null,
      "Type": "ADMISSION",
      "enabled": true,
      "id": "436"
    },
    {
      "Answer": "",
      "AnswerCK": `<p>
    <span style=""><span style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:500;letter-spacing:normal;orphans:2;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">For a smooth admission process, the following documents are required:</span></span><br>
    <b style="-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);box-sizing:border-box;color: #1a1a1a;font-family:Raleway, sans-serif;font-size:13.3333px;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:bolder;letter-spacing:normal;orphans:2;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;"><strong>For Domestic Students:</strong></b>
</p>
<ul style="-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);box-sizing:border-box;color: #1a1a1a;font-family:Raleway, sans-serif;font-size:13.3333px;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:500;letter-spacing:normal;margin-bottom:1rem;margin-top:0px;orphans:2;padding-left:2rem;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">
    <li style="box-sizing:border-box;color: #1a1a1a;">
        Academic certificates from 10th, 12th, and graduation.
    </li>
    <li style="box-sizing:border-box;color: #1a1a1a;">
        Consolidated marksheets for graduation.
    </li>
    <li style="box-sizing:border-box;color: #1a1a1a;">
        A valid government-issued ID such as Aadhar, PAN, or Passport.
    </li>
</ul>
<p>
    <b style="-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);box-sizing:border-box;color: #1a1a1a;font-family:Raleway, sans-serif;font-size:13.3333px;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:bolder;letter-spacing:normal;orphans:2;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;"><strong>For International Students:</strong></b>
</p>
<ul style="-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);box-sizing:border-box;color: #1a1a1a;font-family:Raleway, sans-serif;font-size:13.3333px;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:500;letter-spacing:normal;margin-bottom:1rem;margin-top:0px;orphans:2;padding-left:2rem;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">
    <li style="box-sizing:border-box;color: #1a1a1a;">
        O Level and A Level certificates or equivalent qualifications.
    </li>
    <li style="box-sizing:border-box;color: #1a1a1a;">
        Bachelor's degree certificate with consolidated marksheets.
    </li>
    <li style="box-sizing:border-box;color: #1a1a1a;">
        Passport copy (mandatory).
    </li>
</ul>
<p>
    <span style=""><span style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:500;letter-spacing:normal;orphans:2;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">Once these documents are ready, our admissions team will guide you through the process.</span></span>
</p>`,
      "Question": "What documents are required for admission?",
      "QuestionCK": null,
      "Type": "ADMISSION",
      "enabled": true,
      "id": "437"
    },
    {
      "Answer": "Yes, with online MBA programs, candidates can pursue part-time or full-time jobs. This is because online MBAs do not demand students to attend regular and in-person classes. They allow students the flexibility to balance their studies with their work and family.",
      "AnswerCK": null,
      "Question": " Can the online MBA program be completed while working full-time?",
      "QuestionCK": null,
      "Type": "ADMISSION",
      "enabled": true,
      "id": "438"
    },
    {
      "Answer": "Faculty interaction is facilitated through live Q&A sessions, offline meet-ups, and discussion forums. AI-Professor AMI provides additional support for instant query resolution.",
      "AnswerCK": null,
      "Question": "How can I interact with faculty?",
      "QuestionCK": null,
      "Type": "ACADEMICS",
      "enabled": true,
      "id": "439"
    },
    {
      "Answer": "Yes, over 75 open learning courses and free certifications in areas like Advanced Excel, Leadership, and Strategic HR are available to enhance employability. Collaborative learning opportunities on beSocial further enrich the experience.",
      "AnswerCK": null,
      "Question": "Are additional courses or certifications offered?",
      "QuestionCK": null,
      "Type": "ACADEMICS",
      "enabled": true,
      "id": "440"
    },
    {
      "Answer": "Industry visits allow students to engage with professionals, explore career opportunities, and apply classroom knowledge in real-world scenarios. These visits are a valuable addition to the learning journey.",
      "AnswerCK": null,
      "Question": "What are the advantages of industry visits?",
      "QuestionCK": null,
      "Type": "ACADEMICS",
      "enabled": true,
      "id": "441"
    },
    {
      "Answer": "",
      "AnswerCK": `<p>
    <span style=""><span style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:500;letter-spacing:normal;orphans:2;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">Amity University Online offers:</span></span>
</p>
<ul style="-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);box-sizing:border-box;color: #1a1a1a;font-family:Raleway, sans-serif;font-size:13.3333px;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:500;letter-spacing:normal;margin-bottom:1rem;margin-top:0px;orphans:2;padding-left:2rem;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">
    <li style="box-sizing:border-box;color: #1a1a1a;">
        AI-Professor AMI powered by Chat-GPT 4 &amp; OpenAI technology, available 24/7 for instant doubt clearing, academic guidance, and technical support.
    </li>
    <li style="box-sizing:border-box;color: #1a1a1a;">
        Dedicated student support through calls and chat for resolving queries.
    </li>
    <li style="box-sizing:border-box;color: #1a1a1a;">
        Career assistance, including placement support and resume-building workshops.
    </li>
</ul>`,
      "Question": "What support services are available for students?",
      "QuestionCK": null,
      "Type": "GENERAL",
      "enabled": true,
      "id": "442"
    },
    {
      "Answer": "",
      "AnswerCK": `<p>
        <span style=""><span style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:500;letter-spacing:normal;orphans:2;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">Learning at Amity University Online is conducted through a sophisticated student portal, offering 24/7 access to:</span></span>
      </p>
      <ul style="-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);box-sizing:border-box;color: #1a1a1a;font-family:Raleway, sans-serif;font-size:13.3333px;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:500;letter-spacing:normal;margin-bottom:1rem;margin-top:0px;orphans:2;padding-left:2rem;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">
          <li style="box-sizing:border-box;color: #1a1a1a;">
              Live lectures, recorded sessions, assignments, and quizzes.
          </li>
          <li style="box-sizing:border-box;color: #1a1a1a;">
              Assignments, quizzes, proctored examinations and other academic resources.
          </li>
          <li style="box-sizing:border-box;color: #1a1a1a;">
              Support from AI-Professor AMI for a seamless and engaging learning experience.
          </li>
          <li style="box-sizing:border-box;color: #1a1a1a;">
              Students can also enhance their experience through beSocial, which offers collaboration and networking opportunities.
          </li>
      </ul>`,
      "Question": "How does online learning at Amity University Online work?",
      "QuestionCK": null,
      "Type": "GENERAL",
      "enabled": true,
      "id": "443"
    },{
      "Answer": "Yes, Amity University Online evaluates transfer credits on a case-by-case basis to ensure they meet program requirements. The admissions team guides students through this process.",
      "AnswerCK": null,
      "Question": "Can credits from other institutions be transferred?",
      "QuestionCK": null,
      "Type": "GENERAL",
      "enabled": true,
      "id": "444"
    },{
      "Answer": "Exams are conducted online in a secure and proctored environment on our student portal to maintain academic integrity. Mock exams are provided to familiarize students with the system. Flexible time slots are offered to accommodate learners' schedules.",
      "AnswerCK": null,
      "Question": "How are exams conducted?",
      "QuestionCK": null,
      "Type": "GENERAL",
      "enabled": true,
      "id": "445"
    }
  ],
  "enabled": true,
  "id": "1"
}
